/**
 * Vai trò người dùng và tập role được phép vào khu admin.
 */

export const USER_ROLES = {
  superAdmin: 'super_admin',
  admin: 'admin',
  agent: 'agent',
  user: 'user',
};

export const ADMIN_ROLES = [USER_ROLES.superAdmin, USER_ROLES.admin];
